import { queryString, request } from "./client";

export const productsApi = {
  categories: (language) => request("/api/categories/", { language }),

  subcategories: (categoryId, language) =>
    request(`/api/categories/${categoryId}/subcategories/`, { language }),

  featured: (language) =>
    request("/api/home/products/display/", { language }),

  list: (params, language) =>
    request(`/api/products/?${queryString(params)}`, { language }),

  get: (spu, language) =>
    request(`/api/products/${encodeURIComponent(spu)}/`, { language }),

  similar: (spu, language) =>
    request(`/api/similar-products/${encodeURIComponent(spu)}/`, { language }),
};
